import axiosInstance from './axios';

export async function getHomepageSettings() {
  const response = await axiosInstance.get('/site-settings/homepage');
  return response.data;
}

export async function updateHomepageSettings(data) {
  const response = await axiosInstance.put('/site-settings/homepage', data);
  return response.data;
}

export async function uploadOgImage(file) {
  const formData = new FormData();
  formData.append('image', file);
  const response = await axiosInstance.post('/site-settings/upload-og-image', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
  return response.data;
}
